//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "CreateIntegrationModal",
    components: {
        AQDropdown,
        AQInput,
        AQModal,
        AQButton,
        AQToggle,
        AQDialog,
        AQCard
    },
    props: {
        integrationUsed: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        integrationData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showDialog: false,
            typePassword: false,
            testConnectionBtn: this.$t("gdmIntegration.testConnectionBtn"),
            connectionTested: false,
            loading: false,
            integration: {
                name: this.isEdit ? this.integrationData.connectionName : "",
                type: ""
            },
            connection: {
                host: this.isEdit ? this.integrationData.hostname : "",
                port: this.isEdit ? this.integrationData.port : "",
                database: this.isEdit ? this.integrationData.dbName : "",
                username: "",
                role: null,
                password: ""
            },
            showModal: true,
            defaultSource: "SQLSERVER",
            defaultOracleRole: "normal",
            oracleRoles: [
                {
                    value: "normal",
                    label: "Normal"
                },
                {
                    value: "sysdba",
                    label: "SYSDBA"
                },
                {
                    value: "sysoper",
                    label: "SYSOPER"
                }
            ],
            sourceOptions: [
                {
                    value: "SQLSERVER",
                    label: this.$t("globalDataModel.microsoftSQL")
                },
                {
                    value: "ORACLE",
                    label: this.$t("globalDataModel.oracle")
                },
                {
                    value: "MYSQL",
                    label: this.$t("globalDataModel.MySQL")
                }
            ],
            headerActions: [{
                label: this.$t("globalDataModel.deleteEntity")
            }],
            disableSave: true,
            changeCredentials: false,
            disableTestBtn: true,
            nameWasChanged: false,
            successfulConnection: false,
            wrongPattern: false
        };
    },
    computed: {
        setHeaderActions() {
            return this.isEdit && !this.integrationUsed ? this.headerActions : [];
        },
        setDefaultSourceRole() {
            return this.isEdit ? this.integrationData.role : this.defaultOracleRole;
        },
        setDefaultSource() {
            return this.isEdit ? this.integrationData.dbType : this.defaultSource;
        },
        isOracle() {
            return this.integration.type && this.integration.type[0].value === "ORACLE";
        },
        save() {
            return {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"),
                disabled: this.disableSave
            };
        },
        setTitle() {
            let title = "";
            if (this.isEdit) {
                title = this.$t("gdmIntegration.editIntegration");
            } else {
                title = this.$t("gdmIntegration.createNewIntegration");
            }
            return title;
        }
    },
    watch: {
        connection: {
            handler(val) {
                if (val) {
                    this.disableSave = true;
                }
            },
            deep: true
        },
        "integration.name": function (newVal) {
            if (newVal) {
                if (this.isEdit) {
                    this.nameWasChanged = true;
                    if (this.changeCredentials && !this.connection.username && !this.connection.password) {
                        this.disableSave = true;
                    } else {
                        this.disableSave = false;
                    }
                }
            }
        },
        changeCredentials: {
            handler() {
                if (this.changeCredentials && this.nameWasChanged) {
                    this.disableSave = true;
                }
                if (!this.changeCredentials) {
                    this.connection.username = "";
                    this.connection.password = "";
                    this.connectionTested = false;
                    this.disableSave = !this.nameWasChanged;
                }
            }
        }
    },
    methods: {
        ...mapActions("GDM", ["testItegrationConn", "saveIntegration", "updateIntegration", "deleteIntegration"]),
        removeIntegration() {
            this.deleteIntegration(this.integrationData.connectionCode).then(() => {
                this.$toast.showNotify({
                    message: this.$t("globalDataModel.deletedMsg"),
                    type: "success"
                });
                this.$emit("refreshList");
                this.$emit("input", false);
            });
        },
        testConnection() {
            this.disableSave = true;
            this.loading = true;
            const role = this.isOracle && this.connection.role && this.connection.role[0].value !== "normal" ? ` as ${this.connection.role[0].value}` : "";
            const payload = {
                dbName: this.connection.database,
                dbType: this.integration.type[0].value,
                hostname: this.connection.host,
                password: this.connection.password,
                port: this.connection.port,
                username: this.isOracle ? `${this.connection.username}${role}` : this.connection.username
            };
            this.testItegrationConn(payload).then(data => {
                this.loading = false;
                this.testConnectionlabel = this.$t("gdmIntegration.testAgainConnectionBtn");
                if (data && data.status === 200) {
                    this.iconColor = "positive";
                    this.connectionTested = true;
                    this.connectionStatus = this.$t("gdmIntegration.connectionSucces");
                    this.testConnectionBtn = this.$t("gdmIntegration.testAgainConnectionBtn");
                    this.successfulConnection = true;
                    if (this.integration.name) {
                        this.disableSave = false;
                    }
                }
            }).catch(() => {
                this.loading = false;
                this.connectionTested = true;
                this.iconColor = "negative";
                this.connectionStatus = this.$t("gdmIntegration.connectionError");
                this.testConnectionBtn = this.$t("gdmIntegration.testAgainConnectionBtn");
                this.successfulConnection = false;
            });
        },
        actionsDlg($event) {
            if ($event === "save") {
                let localUsername = "";
                if (this.isOracle) {
                    let role = "";
                    if (this.connection && this.connection.role && this.connection.role[0].value !== "normal") {
                        role = ` as ${this.connection.role[0].value}`;
                    }
                    if (this.isEdit) {
                        if (this.connection.role && this.changeCredentials) {
                            localUsername = `${this.connection.username}${role}`;
                        } else {
                            localUsername = "";
                        }
                    } else {
                        localUsername = `${this.connection.username}${role}`;
                    }
                } else {
                    localUsername = this.connection.username;
                }
                const payload = {
                    active: true,
                    connectionName: this.integration.name,
                    dbName: this.connection.database,
                    dbType: this.integration.type[0].value,
                    hostname: this.connection.host,
                    password: this.connection.password,
                    port: this.connection.port,
                    username: localUsername,
                    connectionCode: this.isEdit ? this.integrationData.connectionCode : ""
                };
                if (!this.isEdit) {
                    this.saveIntegration(payload).then(() => {
                        this.$emit("refreshList");
                        this.$emit("input", false);
                    });
                } else {
                    this.updateIntegration(payload).then(() => {
                        this.$emit("refreshList");
                        this.$emit("input", false);
                    });
                }
            } else if ($event === this.$t("globalDataModel.deleteEntity")) {
                this.showDialog = true;
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        enableTestBtn() {
            if (this.connection.username && this.connection.password) {
                this.disableTestBtn = false;
            } else {
                this.disableTestBtn = true;
            }
        },
        checkIntegrationName() {
            if (this.integration.name) {
                // eslint-disable-next-line
                const validatePattern = new RegExp("^[a-zA-Z][ a-zA-Z0-9\_-]*$");
                this.wrongPattern = !validatePattern.test(this.integration.name);
                if (!this.wrongPattern && this.connectionTested && this.successfulConnection) {
                    this.disableSave = false;
                } else {
                    this.disableSave = true;
                }
            } else {
                this.wrongPattern = false;
                this.disableSave = true;
            }
        }
    }
};
